import { FullScreenLoading } from '@backrs_ui/common-ui';

import { useGetFamilyAccountQuery } from '@backrs_ui/grow-ui/src/redux/family/family.api';

import { Box } from '@mui/material';

import { FamilyPage } from './components/FamilyPage';

type FamilyPageContainerProps = Readonly<{
  returnToDefaultTab: () => void;
}>;

export const FamilyPageContainer = ({ returnToDefaultTab }: FamilyPageContainerProps) => {
  const { data: familyAccount, error, isLoading } = useGetFamilyAccountQuery(undefined);

  if (error) {
    return <Box>Error loading family account</Box>;
  }

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return <FamilyPage familyAccount={familyAccount} returnToDefaultTab={returnToDefaultTab} />;
};
